import { render, staticRenderFns } from "./TerrainTemplates.vue?vue&type=template&id=08024a42&scoped=true"
import script from "./TerrainTemplates.vue?vue&type=script&lang=js"
export * from "./TerrainTemplates.vue?vue&type=script&lang=js"
import style0 from "./TerrainTemplates.vue?vue&type=style&index=0&id=08024a42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08024a42",
  null
  
)

export default component.exports